import { restoreMediaViewSelection } from "./restoreMediaViewSelection.js";
import { getRmlMediaBridge } from "../hooks/tree/bridge/rmlMediaBridge.js";
function isAttachmentsBrowserSortable(element) {
    try {
        const { attachments } = element.attachmentsBrowser;
        return !attachments.$el.sortable("option", "disabled");
    } catch (e) {
        return false;
    }
}
function isAttachmentsGalleryEdit(attachments) {
    try {
        return [
            "gallery-edit",
            "playlist-edit",
            "video-playlist-edit"
        ].indexOf(attachments.options.model.get("toolbar")) > -1;
    } catch (e) {
        return false;
    }
}
/**
 * When a tree gets initialized then check if it is a modal and modify the state.
 */ function applyModalTreeInit(controller, state, { isModal }) {
    if (isModal && controller.attachmentsBrowser) {
        const browser = controller.attachmentsBrowser;
        state.isResizable = false;
        state.isSticky = false;
        state.isStickyHeader = false;
        state.isFullWidth = true;
        state.isWPAttachmentsSortMode = isAttachmentsBrowserSortable(controller);
        const changeOrderBy = ()=>controller.setState({
                isWPAttachmentsSortMode: isAttachmentsBrowserSortable(controller)
            });
        const { props } = browser.collection;
        props.on("change:orderby", changeOrderBy);
        controller._unsubscribeChangeOrderBy = ()=>props.off("change:orderby", changeOrderBy);
        const { controller: { modal } } = browser;
        restoreMediaViewSelection(modal._rmlFolder, controller.props.store, getRmlMediaBridge(controller.attachmentsBrowser), ({ id })=>{
            browser.attachments._rmlInitialSetted = true;
            state.initialSelectedId = id;
        });
    }
}
/**
 * When a modal tree gets destroyed save the last selected folder in the modal.
 */ function applyModalTreeDestroy(controller, _state, { isModal, store }) {
    if (isModal && controller.attachmentsBrowser) {
        const browser = controller.attachmentsBrowser;
        browser.controller.modal._rmlFolder = store.selectedId;
        const { _unsubscribeChangeOrderBy } = controller;
        _unsubscribeChangeOrderBy?.();
        controller._unsubscribeChangeOrderBy = undefined;
    }
}
function prepareModalSidebar(context) {
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
}
export { applyModalTreeDestroy, applyModalTreeInit, isAttachmentsGalleryEdit, prepareModalSidebar };
